/** * * Asynchronously loads the component for
FAQ
* */ import { lazyLoad } from "utils/loadable";
export const FAQ = lazyLoad(
  () => import("./index"),
  (module) => module.FAQ
);
